module.exports = __webpack_public_path__ + "157d83942e716bfde639fdcf6510af26.pdf";